import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { Box, Grid, Paper, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import UserList from './UserList';
import NewUser from './NewUser';
import { fetchUsers } from '../UserManagement/UserSlice';
import { useAppDispatch } from '../../app/hooks';

function UserManagement() {
  const [showNew, setShowNew] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchUsers());
  }, []);

  return (
    <>
      <Box display="flex" flexDirection="column" height="100%">
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={4} mb={1}>
          <Box display="flex" alignItems="center">
            {/* <Button
              className="bold-text"
              sx={{
                bgcolor: 'var(--color-sand-default)',
                color: 'var(--color-offwhite)',
                py: '20px',
                ':hover': {
                  bgcolor: 'var(--color-sand-highlight)',
                  color: 'var(--color-dark-gray)'
                },
                height: '56px',
                maxWidth: '358px',
                mr: 2
              }}
              onClick={() => setShowNew(true)}
              fullWidth
              size="large"
              variant="contained"
              startIcon={<AddIcon />}
            >
              Add New User
            </Button> */}
          </Box>
          <Typography
            className="bold-text"
            sx={{
              color: 'var(--color-sand-highlight)',
              fontSize: '32px'
            }}
            align="right"
            variant="h3"
          >
            User Management
          </Typography>
        </Box>

        <Paper
          sx={{
            padding: '20px 30px',
            backgroundColor: 'var(--color-dark-gray)',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflow: 'auto',
            mt: 3
          }}
        >
          <Typography
            sx={{ color: 'var(--color-offwhite)', fontSize: '28px' }}
            align="left"
            variant="h4"
            gutterBottom
          >
            Users
          </Typography>

          <UserList />
        </Paper>
      </Box>

      {showNew && <NewUser open={showNew} onClose={() => setShowNew(false)} />}
    </>
  );
}

export default UserManagement;
